'use client';

import { type Dispatch, forwardRef, type SetStateAction } from 'react';

export interface ICheckbox {
  id: string;
  label: string;
  checked: boolean;
  setChecked: Dispatch<SetStateAction<boolean>>;
}

export const CheckboxAppFolder = forwardRef<HTMLInputElement, ICheckbox>(({ id, label, checked, setChecked }, ref) => (
  <div className="inline-flex items-center">
    <label className="relative flex cursor-pointer items-center py-3 pr-2" htmlFor="checkbox" data-ripple-dark="true">
      <input
        type="checkbox"
        id={id}
        ref={ref}
        className="before:content[''] peer relative size-5 cursor-pointer appearance-none rounded border border-gray-100 before:bg-turquoise-500 checked:border-turquoise-500 checked:bg-turquoise-500 checked:before:bg-turquoise-500 hover:before:opacity-10"
        checked={checked}
        onChange={() => setChecked(!checked)}
      />
      <div className="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 pr-2 text-white opacity-0 transition-opacity peer-checked:opacity-100">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="size-3.5"
          viewBox="0 0 20 20"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
    </label>
    <span className="cursor-pointer text-sm" onClick={() => setChecked(!checked)}>
      {label}
    </span>
  </div>
));

CheckboxAppFolder.displayName = 'CheckboxAppFolder';
